import React from 'react';

import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppRoutes } from 'AppRoutes';
import { GlobalSVGDefinitions } from 'icons/GlobalSVGDefinitions';
import { queryClientSingleton } from 'shared/utils/query-client-singleton';
import { ThemeProvider } from 'Theme';

export function App() {
  return (
    <ThemeProvider>
      <Notifications />
      <QueryClientProvider client={queryClientSingleton}>
        <ReactQueryDevtools initialIsOpen={false} />
        {/* Ensures SVG gradients are globally available to fix rendering issues with icons */}
        <GlobalSVGDefinitions />
        <AppRoutes />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
